import classNames from "classnames";
import {
  Bookmark,
  ChartSpline,
  FileText,
  Folder,
  HardDrive,
  Library,
  Route,
  Table2,
} from "lucide-react";

import { type ContextType } from "../contextType";

/**
 * What a context chip can show an icon for: every context type, plus the
 * View loaded on a table, which shares the table's chip but not its glyph.
 * The bookmark is the View picker's own icon, so the chip reads as a View.
 */
export type ContextIconKind = ContextType | "view";

interface ContextIconProps {
  contextType: ContextIconKind;
  className?: classNames.Argument;
}

/**
 * Context icon component for a given context type.
 */
export function ContextIcon(props: ContextIconProps) {
  const { contextType, className } = props;

  switch (contextType) {
    case "dataset":
      return <Folder className={classNames(className)} />;
    case "file":
      return <FileText className={classNames(className)} />;
    case "collection":
      return <Library className={classNames(className)} />;
    case "device":
      return <HardDrive className={classNames(className)} />;
    case "session":
      return <Route className={classNames(className)} />;
    case "table":
      return <Table2 className={classNames(className)} />;
    case "view":
      return <Bookmark className={classNames(className)} />;
    case "viz_state":
      return <ChartSpline className={classNames(className)} />;
  }
}
